export default {
  error: {
    onlineCheck:
      '現在のログインユーザー数が上限を超えています。お待ちいただくか、後で再試行してください。',
  },
}
